import buildThreadContentItems from '@/lib/threads/buildThreadContentItems.js';
import getThreadId from '@/lib/threads/getThreadId.js';
import matchesThreadListScope from '@/lib/threads/matchesThreadListScope.js';

const replaceThreadContentItemsForScope = ({ existingThreadContent = [], existingThreads = [], incomingThreadContent = [], threadListScope } = {}) => {
  const ownedThreadIds = new Set(
    (existingThreads || [])
      .filter((thread) => {
        return matchesThreadListScope({
          thread,
          threadListScope
        });
      })
      .map((thread) => {
        return getThreadId(thread);
      })
      .filter(Boolean)
  );
  const preservedItems = buildThreadContentItems(existingThreadContent).filter((item) => {
    return !ownedThreadIds.has(item?.threadId);
  });

  return buildThreadContentItems([...preservedItems, ...buildThreadContentItems(incomingThreadContent)]);
};

export default replaceThreadContentItemsForScope;
